import { Injectable } from '@angular/core';
import {MasterPassApi} from "../../api/master-pass/master-pass.api.class";
import {Observable} from "rxjs";
import {RedirectRequest} from "../../interfaces/master-pass/RedirectRequest";

@Injectable({
  providedIn: 'root'
})
export class MasterPassService {


  constructor(private masterPassApi : MasterPassApi) { }

  initializeQRCode( sessionToken : string ) {
      return this.masterPassApi.initializeQRCode(sessionToken);
  }

  public redirectMasterPass(sessionToken: string, redirectRequest: RedirectRequest): Observable<any> {
    return this.masterPassApi.redirectMasterPass(sessionToken, redirectRequest);
  }

  public validateMasterPass(sessionToken: string): Observable<any> {
    return this.masterPassApi.validateMasterPass(sessionToken);
  }
}
